import { render } from "./B2bPageCmrEmits.vue?vue&type=template&id=464a78af&scoped=true&lang=pug"
import script from "./B2bPageCmrEmits.vue?vue&type=script&lang=js"
export * from "./B2bPageCmrEmits.vue?vue&type=script&lang=js"

import "./B2bPageCmrEmits.vue?vue&type=style&index=0&id=464a78af&lang=scss&scoped=true"
import "./B2bPageCmrEmits.vue?vue&type=style&index=1&id=464a78af&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464a78af"]])

export default __exports__